var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgHouse = function SvgHouse(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 98 98",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "house_svg__a",
    width: 98,
    height: 98,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    x: 1,
    y: 1,
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 2,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#house_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DADBDD",
    fillRule: "evenodd",
    d: "m62.407 41.678 5.997 6.01a2.277 2.277 0 0 1 0 3.215 2.26 2.26 0 0 1-1.605.666 2.26 2.26 0 0 1-1.604-.666L50.2 35.873c-.486-.485-1.347-.485-1.835.002L33.373 50.903a2.264 2.264 0 0 1-3.21 0 2.278 2.278 0 0 1 0-3.214L45.159 32.66c2.203-2.212 6.04-2.216 8.248-.004l4.465 4.475v-2.397a2.27 2.27 0 0 1 2.267-2.273 2.27 2.27 0 0 1 2.27 2.273v6.943ZM48.495 40.19a1.111 1.111 0 0 1 1.575 0l13.187 13.215c.21.209.327.494.327.791v9.639a4.091 4.091 0 0 1-4.087 4.095h-6.53V57.794h-7.371V67.93h-6.53a4.091 4.091 0 0 1-4.086-4.095v-9.639c0-.297.118-.582.326-.79L48.495 40.19Z",
    clipRule: "evenodd"
  }))));
};
export default SvgHouse;